// auto-generated by bin/genVersion.ts
export const VERSION = '1.18.2';
//# sourceMappingURL=version.js.map